'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VIEW_TRIP = exports.STANDARD = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _templateComponentTypes = require('constants/templateComponentTypes');

var componentTypes = _interopRequireWildcard(_templateComponentTypes);

var _fontFamilies = require('constants/fontFamilies');

var _languages = require('constants/languages');

var _currencyFormats = require('constants/currencyFormats');

var _timeFormats = require('constants/timeFormats');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STANDARD = exports.STANDARD = 'tq-plus-admin/templates/type/STANDARD';
var VIEW_TRIP = exports.VIEW_TRIP = 'tq-plus-admin/templates/type/VIEW_TRIP';

exports.default = function () {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : STANDARD;

    var components = {
        root: {
            id: 'root',
            type: componentTypes.CONTAINER,
            name: 'Background',
            color: '#333',
            backgroundColor: '#CCC',
            direction: 'vertical',
            childComponents: ['refNumber', 'header', 'tabs', 'footer']
        },
        refNumber: {
            id: 'refNumber',
            type: componentTypes.LABEL,
            name: 'refNumber',
            label: 'REFERENCE NUMBER: VALUE',
            value: '',
            placeholder: '',
            color: '#000',
            backgroundColor: '#000',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        header: {
            id: 'header',
            type: componentTypes.TEXTAREA,
            name: 'Header',
            label: 'Header',
            value: '',
            placeholder: 'Type the header',
            color: '#333',
            backgroundColor: '#FFF',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        tabs: {
            id: 'tabs',
            type: componentTypes.TABS,
            name: 'Tabs',
            activeTab: 0,
            tabs: ['Air/Rail', 'Hotel', 'Car', 'Rail Card', 'Rail Card Receipt'],
            panels: ['flight', 'hotel', 'car', 'railcard', 'railcardreceipt']
        },
        flight: {
            id: 'flight',
            type: componentTypes.AIR,
            name: 'Air',
            color: '#333',
            backgroundColor: '#fff',
            direction: 'vertical',
            childComponents: ['AirCategoryHeader', 'FlightOptionContainer', 'Cities', 'FlightContainer', 'DurationContainer', 'TicketHeader', 'TicketDetails', 'PriceHeader', 'PriceContainer', 'FlightCommentContainer', 'RailCommentContainer', 'FlightRules']
        },
        AirCategoryHeader: {
            id: 'AirCategoryHeader',
            type: componentTypes.CONTAINER,
            name: 'AirCategoryHeader',
            label: 'Air Category Header',
            value: 'Air Category Header',
            color: '#333',
            backgroundColor: '#0C3B55',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            childComponents: ['AirCategoryLabel']
        },
        AirCategoryLabel: {
            id: 'AirCategoryLabel',
            type: componentTypes.LABEL,
            name: 'AirCategoryLabel',
            label: 'Air Category Label',
            value: 'Air Category Label',
            color: '#FFF',
            backgroundColor: '#0C3B55',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        FlightOptionContainer: {
            id: 'FlightOptionContainer',
            type: componentTypes.CONTAINER,
            name: 'AirOptionContainer',
            label: 'AirOptionContainer',
            value: 'Air Option',
            color: '#333',
            backgroundColor: '#005D8C',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            childComponents: ['FlightOptionLabel']
        },
        FlightOptionLabel: {
            id: 'FlightOptionLabel',
            type: componentTypes.LABEL,
            name: 'AirOptionLabel',
            label: 'Air Option',
            value: 'Air Option',
            color: '#FFF',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        Cities: {
            id: 'Cities',
            type: componentTypes.CONTAINER,
            name: 'Cities',
            label: 'Cities',
            value: '',
            color: '#333',
            backgroundColor: '#FFF',
            fontSize: '15px',
            direction: 'horizontal',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            childComponents: ['Segment_Cities', 'Time']
        },
        Segment_Cities: {
            id: 'Segment_Cities',
            type: componentTypes.LABEL,
            name: 'Segment_Cities',
            label: 'Dept_City > Arr_City',
            value: '',
            color: '#005d8c',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            lg: 6,
            md: 6,
            sm: 6
        },
        Time: {
            id: 'Time',
            type: componentTypes.LABEL,
            name: 'Time',
            label: '00h 00m',
            value: '11:14',
            color: '#005d8c',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            lg: 6,
            md: 6,
            sm: 6
        },
        FlightContainer: {
            id: 'FlightContainer',
            type: componentTypes.CONTAINER,
            name: 'FlightContainer',
            label: 'FlightContainer',
            value: '',
            color: '#333',
            backgroundColor: '#DFEAF0',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            direction: 'horizontal',
            childComponents: ['FlightNumContainer', 'DepartContainer', 'ArriveContainer']
        },
        FlightNumContainer: {
            id: 'FlightNumContainer',
            type: componentTypes.CONTAINER_NO_PROPS,
            name: 'FlightNumContainer',
            lg: 2,
            md: 2,
            sm: 2,
            direction: 'vertical',
            childComponents: ['FlightNumberLabel']
        },
        FlightNumberLabel: {
            id: 'FlightNumberLabel',
            type: componentTypes.LABEL,
            name: 'FlightNumberLabel',
            label: 'FLIGHT NUM',
            value: '',
            color: '#999',
            fontSize: '13px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        DepartContainer: {
            id: 'DepartContainer',
            type: componentTypes.CONTAINER_NO_PROPS,
            name: 'DepartContainer',
            lg: 5,
            md: 5,
            sm: 5,
            direction: 'vertical',
            childComponents: ['DepartTitleLabel', 'DepartValueLabel']
        },
        DepartTitleLabel: {
            id: 'DepartTitleLabel',
            type: componentTypes.LABEL,
            name: 'DepartTitleLabel',
            label: 'DEPART',
            value: 'DEPART:',
            color: '#999',
            fontWeight: '500',
            fontSize: '18px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        DepartValueLabel: {
            id: 'DepartValueLabel',
            type: componentTypes.LABEL,
            name: 'DepartValueLabel',
            label: 'Arpt city, City (CITY_CODE): DDD MMM dd YYYY at HH:MM Terminal X',
            value: '',
            color: '#333',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        ArriveContainer: {
            id: 'ArriveContainer',
            type: componentTypes.CONTAINER_NO_PROPS,
            name: 'ArriveContainer',
            lg: 5,
            md: 5,
            sm: 5,
            direction: 'vertical',
            childComponents: ['ArriveTitleLabel', 'ArriveValueLabel']
        },
        ArriveTitleLabel: {
            id: 'ArriveTitleLabel',
            type: componentTypes.LABEL,
            name: 'ArriveTitleLabel',
            label: 'ARRIVE',
            value: 'ARRIVE:',
            color: '#999',
            fontWeight: '500',
            fontSize: '18px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        ArriveValueLabel: {
            id: 'ArriveValueLabel',
            type: componentTypes.LABEL,
            name: 'ArriveValueLabel',
            label: 'Arpt city, City (CITY_CODE): DDD MMM dd YYYY at HH:MM Terminal X',
            value: '',
            color: '#333',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        DurationContainer: {
            id: 'DurationContainer',
            type: componentTypes.CONTAINER,
            name: 'DurationContainer',
            label: 'DurationContainer',
            value: '',
            color: '#333',
            backgroundColor: '#DFEAF0',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            direction: 'horizontal',
            childComponents: ['DurationLabel', 'DurationValue']
        },
        DurationLabel: {
            id: 'DurationLabel',
            type: componentTypes.LABEL,
            name: 'DurationLabel',
            label: 'Duration:',
            value: '',
            color: '#333',
            fontWeight: '500',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            lg: 2,
            md: 2,
            sm: 2
        },
        DurationValue: {
            id: 'DurationValue',
            type: componentTypes.LABEL,
            name: 'DurationValue',
            label: 'Value',
            value: '',
            color: '#999',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            lg: 2,
            md: 2,
            sm: 2
        },
        TicketHeader: {
            id: 'TicketHeader',
            type: componentTypes.CONTAINER,
            name: 'TicketHeader',
            label: 'TicketHeader',
            value: '',
            backgroundColor: '#DFEAF0',
            direction: 'horizontal',
            childComponents: ['TicketHeaderTicketText', 'TicketHeaderCitiesText']
        },
        TicketHeaderTicketText: {
            id: 'TicketHeaderTicketText',
            type: componentTypes.LABEL,
            name: 'TicketHeaderTicketText',
            label: 'Ticket 1',
            value: 'Ticket 1',
            color: '#666',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            lg: 2,
            md: 2,
            sm: 2
        },
        TicketHeaderCitiesText: {
            id: 'TicketHeaderCitiesText',
            type: componentTypes.LABEL,
            name: 'TicketHeaderCitiesText',
            label: 'City1 > City2',
            value: 'City1 > City2',
            color: '#333',
            backgroundColor: '#DFEAF0',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            lg: 4,
            md: 4,
            sm: 4
        },
        TicketDetails: {
            id: 'TicketDetails',
            type: componentTypes.CONTAINER,
            name: 'TicketDetails',
            label: 'TicketDetails',
            value: '',
            backgroundColor: '#DFEAF0',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            direction: 'horizontal',
            childComponents: ['TicketPricePerPtcContainer', 'TicketApproximatePtcContainer']
        },
        TicketPricePerPtcContainer: {
            id: 'TicketPricePerPtcContainer',
            type: componentTypes.CONTAINER_NO_PROPS,
            name: 'PricePerPtcContainer',
            lg: 6,
            md: 6,
            sm: 6,
            direction: 'horizontal',
            childComponents: ['TicketPricePerPtcLabel', 'TicketPricePerPtcValue']
        },
        TicketPricePerPtcLabel: {
            id: 'TicketPricePerPtcLabel',
            type: componentTypes.LABEL,
            name: 'PricePerPtcLabel',
            label: 'Price per PTC:',
            value: '',
            color: '#333',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            lg: 6,
            md: 6,
            sm: 6
        },
        TicketPricePerPtcValue: {
            id: 'TicketPricePerPtcValue',
            type: componentTypes.LABEL,
            name: 'PricePerPtcValue',
            label: 'Value',
            value: '',
            color: '#333',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            lg: 2,
            md: 2,
            sm: 2
        },
        TicketApproximatePtcContainer: {
            id: 'TicketApproximatePtcContainer',
            type: componentTypes.CONTAINER_NO_PROPS,
            name: 'ApproximatePtcContainer',
            lg: 6,
            md: 6,
            sm: 6,
            direction: 'vertical',
            childComponents: ['TicketApproximatePtcValue', 'TicketApproximatePtcLabel']
        },
        TicketApproximatePtcValue: {
            id: 'TicketApproximatePtcValue',
            type: componentTypes.LABEL,
            name: 'ApproximatePtcValue',
            label: '000.00 CUR',
            value: '',
            color: '#333',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        TicketApproximatePtcLabel: {
            id: 'TicketApproximatePtcLabel',
            type: componentTypes.LABEL,
            name: 'ApproximatePtcLabel',
            label: 'Approximate Total - PTC',
            value: '',
            color: '#333',
            fontWeight: '500',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        PriceHeader: {
            id: 'PriceHeader',
            type: componentTypes.CONTAINER,
            name: 'PriceHeader',
            label: 'PriceHeader',
            backgroundColor: '#DFEAF0',
            direction: 'horizontal',
            childComponents: ['PriceHeaderTotalText']
        },
        PriceHeaderTotalText: {
            id: 'PriceHeaderTotalText',
            type: componentTypes.LABEL,
            name: 'PriceHeaderTotalText',
            label: 'Total',
            value: 'Total',
            color: '#999',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        PriceContainer: {
            id: 'PriceContainer',
            type: componentTypes.CONTAINER,
            name: 'PriceContainer',
            label: 'PriceContainer',
            value: '',
            backgroundColor: '#DFEAF0',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            direction: 'horizontal',
            childComponents: ['PricePerPtcContainer', 'ApproximatePtcContainer']
        },
        PricePerPtcContainer: {
            id: 'PricePerPtcContainer',
            type: componentTypes.CONTAINER_NO_PROPS,
            name: 'PricePerPtcContainer',
            lg: 6,
            md: 6,
            sm: 6,
            direction: 'horizontal',
            childComponents: ['PricePerPtcLabel', 'PricePerPtcValue']
        },
        PricePerPtcLabel: {
            id: 'PricePerPtcLabel',
            type: componentTypes.LABEL,
            name: 'PricePerPtcLabel',
            label: 'Price per PTC:',
            value: '',
            color: '#999',
            fontSize: '18px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            lg: 6,
            md: 6,
            sm: 6
        },
        PricePerPtcValue: {
            id: 'PricePerPtcValue',
            type: componentTypes.LABEL,
            name: 'PricePerPtcValue',
            label: 'Value',
            value: '',
            color: '#333',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            lg: 2,
            md: 2,
            sm: 2
        },
        ApproximatePtcContainer: {
            id: 'ApproximatePtcContainer',
            type: componentTypes.CONTAINER_NO_PROPS,
            name: 'ApproximatePtcContainer',
            lg: 6,
            md: 6,
            sm: 6,
            direction: 'vertical',
            childComponents: ['ApproximatePtcValue', 'ApproximatePtcLabel']
        },
        ApproximatePtcValue: {
            id: 'ApproximatePtcValue',
            type: componentTypes.LABEL,
            name: 'ApproximatePtcValue',
            label: '000.00 CUR',
            value: '',
            color: '#333',
            fontWeight: '500',
            fontSize: '18px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        ApproximatePtcLabel: {
            id: 'ApproximatePtcLabel',
            type: componentTypes.LABEL,
            name: 'ApproximatePtcLabel',
            label: 'Approximate Total - PTC',
            value: '',
            color: '#333',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        FlightCommentContainer: {
            id: 'FlightCommentContainer',
            type: componentTypes.CONTAINER,
            name: 'FlightCommentContainer',
            backgroundColor: '#DFEAF0',
            direction: 'vertical',
            childComponents: ['FlightComment']
        },
        FlightComment: {
            id: 'FlightComment',
            type: componentTypes.TEXTAREA,
            name: 'FlightComment',
            label: 'Air Comment',
            value: '',
            placeholder: 'Comment for air segments',
            color: '#999',
            backgroundColor: '#fff',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        RailCommentContainer: {
            id: 'RailCommentContainer',
            type: componentTypes.CONTAINER,
            name: 'RailCommentContainer',
            backgroundColor: '#DFEAF0',
            direction: 'vertical',
            childComponents: ['RailComment']
        },
        RailComment: {
            id: 'RailComment',
            type: componentTypes.TEXTAREA,
            name: 'RailComment',
            label: 'Rail Comment',
            value: '',
            placeholder: 'Comment for rail segments',
            color: '#999',
            backgroundColor: '#fff',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        FlightRules: {
            id: 'FlightRules',
            type: componentTypes.LABEL,
            name: 'FlightRules',
            label: 'RULES: RULES CONTENT',
            value: '',
            placeholder: '',
            color: '#000',
            backgroundColor: '#000',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        /////////***CAR***////////////
        car: {
            id: 'car',
            type: componentTypes.CAR,
            name: 'car',
            color: '#333',
            backgroundColor: '#fff',
            direction: 'vertical',
            childComponents: ['CarCategoryHeader', 'CarOptionContainer', 'CarCompanyContainer', 'CarContainer', 'CompactManualContainer', 'TotalContainer', 'CarCommentContainer']
        },
        CarCategoryHeader: {
            id: 'CarCategoryHeader',
            type: componentTypes.CONTAINER,
            name: 'CarCategoryHeader',
            label: 'Car Category Header',
            value: 'Car Category Header',
            color: '#333',
            backgroundColor: '#0C3B55',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            childComponents: ['CarCategoryLabel']
        },
        CarCategoryLabel: {
            id: 'CarCategoryLabel',
            type: componentTypes.LABEL,
            name: 'CarCategoryLabel',
            label: 'Car Category Label',
            value: 'Car Category Label',
            color: '#FFF',
            backgroundColor: '#0C3B55',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        CarOptionContainer: {
            id: 'CarOptionContainer',
            type: componentTypes.CONTAINER,
            name: 'CarOptionContainer',
            label: 'FlightOptionContainer',
            value: 'Car Option',
            color: '#333',
            backgroundColor: '#005d8c',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            childComponents: ['CarOptionLabel']
        },
        CarOptionLabel: {
            id: 'CarOptionLabel',
            type: componentTypes.LABEL,
            name: 'CarOptionLabel',
            label: 'Car Option',
            value: 'Car Option',
            color: '#FFF',
            backgroundColor: '#005d8c',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        CarCompanyContainer: {
            id: 'CarCompanyContainer',
            type: componentTypes.CONTAINER,
            name: 'CarCompanyContainer',
            label: 'CarCompanyContainer',
            value: '',
            color: '#333',
            backgroundColor: '#fff',
            fontSize: '15px',
            direction: 'horizontal',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            childComponents: ['CarCompanyLabel']
        },
        CarCompanyLabel: {
            id: 'CarCompanyLabel',
            type: componentTypes.LABEL,
            name: 'CarCompanyLabel',
            label: 'Car Rental Company Name',
            value: '',
            color: '#005d8c',
            backgroundColor: '#DFEAF0',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        CarContainer: {
            id: 'CarContainer',
            type: componentTypes.CONTAINER,
            name: 'CarContainer',
            label: 'CarContainer',
            value: '',
            color: '#333',
            backgroundColor: '#DFEAF0',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            direction: 'horizontal',
            childComponents: ['CarIconContainer', 'CarPickUpContainer', 'CarDropOffContainer']
        },
        CarIconContainer: {
            id: 'CarIconContainer',
            type: componentTypes.CONTAINER_NO_PROPS,
            name: 'CarIconContainer',
            lg: 2,
            md: 2,
            sm: 2,
            direction: 'vertical'
        },
        CarPickUpContainer: {
            id: 'CarPickUpContainer',
            type: componentTypes.CONTAINER_NO_PROPS,
            name: 'CarPickUpContainer',
            lg: 5,
            md: 5,
            sm: 5,
            direction: 'vertical',
            childComponents: ['PickupTitleLabel', 'PickupValueLabel']
        },
        PickupTitleLabel: {
            id: 'PickupTitleLabel',
            type: componentTypes.LABEL,
            name: 'PickupTitleLabel',
            label: 'Pick Up',
            value: 'Pick Up',
            color: '#999',
            fontWeight: '500',
            fontSize: '18px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        PickupValueLabel: {
            id: 'PickupValueLabel',
            type: componentTypes.LABEL,
            name: 'PickupValueLabel',
            label: 'ADDRESS: DDD MMM dd YYYY at HH:MM',
            value: '',
            color: '#333',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        CarDropOffContainer: {
            id: 'CarDropOffContainer',
            type: componentTypes.CONTAINER_NO_PROPS,
            name: 'CarDropOffContainer',
            lg: 5,
            md: 5,
            sm: 5,
            direction: 'vertical',
            childComponents: ['DropOffTitleLabel', 'DropOffValueLabel']

        },
        DropOffTitleLabel: {
            id: 'DropOffTitleLabel',
            type: componentTypes.LABEL,
            name: 'DropOffTitleLabel',
            label: 'Drop Off',
            value: 'Drop Off',
            color: '#999',
            backgroundColor: '#DFEAF0',
            fontWeight: '500',
            fontSize: '18px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        DropOffValueLabel: {
            id: 'DropOffValueLabel',
            type: componentTypes.LABEL,
            name: 'DropOffValueLabel',
            label: 'ADDRESS: DDD MMM dd YYYY at HH:MM',
            value: '',
            color: '#333',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        CompactManualContainer: {
            id: 'CompactManualContainer',
            type: componentTypes.CONTAINER,
            name: 'CompactManualContainer',
            label: 'CompactManualContainer',
            value: '',
            backgroundColor: '#DFEAF0',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            direction: 'horizontal',
            childComponents: ['CompactManualLabel']
        },
        CompactManualLabel: {
            id: 'CompactManualLabel',
            type: componentTypes.LABEL,
            name: 'CompactManualLabel',
            label: 'Compact Manual',
            value: '',
            color: '#999',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        TotalContainer: {
            id: 'TotalContainer',
            type: componentTypes.CONTAINER,
            name: 'TotalContainer',
            label: 'TotalContainer',
            value: '',
            backgroundColor: '#DFEAF0',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            direction: 'horizontal',
            childComponents: ['DailyRateContainer', 'ApproximateTotalContainer']
        },
        DailyRateContainer: {
            id: 'DailyRateContainer',
            type: componentTypes.CONTAINER_NO_PROPS,
            name: 'DailyRateContainer',
            lg: 6,
            md: 6,
            sm: 6,
            direction: 'horizontal',
            childComponents: ['DailyRateTitleLabel', 'DailyRateValueLabel']
        },
        DailyRateTitleLabel: {
            id: 'DailyRateTitleLabel',
            type: componentTypes.LABEL,
            name: 'DailyRateTitleLabel',
            label: 'Daily Rate',
            value: 'Daily Rate:',
            color: '#333',
            fontWeight: '500',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            lg: 6,
            md: 6,
            sm: 6
        },
        DailyRateValueLabel: {
            id: 'DailyRateValueLabel',
            type: componentTypes.LABEL,
            name: 'DailyRateValueLabel',
            label: 'Value',
            value: '',
            color: '#999',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            lg: 2,
            md: 2,
            sm: 2
        },
        ApproximateTotalContainer: {
            id: 'ApproximateTotalContainer',
            type: componentTypes.CONTAINER_NO_PROPS,
            name: 'ApproximateTotalContainer',
            lg: 6,
            md: 6,
            sm: 6,
            direction: 'vertical',
            childComponents: ['ApproximateTotalValueLabel', 'ApproximateTotalTitleLabel']
        },
        ApproximateTotalTitleLabel: {
            id: 'ApproximateTotalTitleLabel',
            type: componentTypes.LABEL,
            name: 'ApproximateTotalTitleLabel',
            label: 'Approximate total',
            value: 'Approximate total',
            color: '#999',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        ApproximateTotalValueLabel: {
            id: 'ApproximateTotalValueLabel',
            type: componentTypes.LABEL,
            name: 'ApproximateTotalValueLabel',
            label: '000.00 CUR',
            value: '',
            color: '#333',
            fontSize: '18px',
            fontWeight: '500',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        CarCommentContainer: {
            id: 'CarCommentContainer',
            type: componentTypes.CONTAINER,
            name: 'CarCommentContainer',
            color: '#999',
            backgroundColor: '#DFEAF0',
            direction: 'vertical',
            childComponents: ['CarComment']
        },
        CarComment: {
            id: 'CarComment',
            type: componentTypes.TEXTAREA,
            name: 'CarComment',
            label: 'Car Comment',
            value: '',
            placeholder: 'Comment for car segments',
            color: '#999',
            backgroundColor: '#fff',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        // //// RAIL CARD ///////
        railcard: {
            id: 'railcard',
            type: componentTypes.CAR,
            name: 'railcard',
            color: '#333',
            backgroundColor: '#fff',
            direction: 'vertical',
            childComponents: ['RailCardCategoryHeader', 'RailCardOptionContainer', 'RailCardNameContainer', 'RailCardContainer', 'RailCardInfoContainer', 'RailCardTotalContainer', 'RailCardCommentContainer', 'RailCardRules']
        },
        RailCardCategoryHeader: {
            id: 'RailCardCategoryHeader',
            type: componentTypes.CONTAINER,
            name: 'Rail Card Category Header',
            label: 'Rail Card Category Header',
            value: 'Rail Card Category Header',
            backgroundColor: '#0C3B55',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            childComponents: ['RailCardCategoryLabel']
        },
        RailCardCategoryLabel: {
            id: 'RailCardCategoryLabel',
            type: componentTypes.LABEL,
            name: 'Rail Card Category Label',
            label: 'Rail Card Category Label',
            value: 'Rail Card Category Label',
            color: '#FFF',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        RailCardOptionContainer: {
            id: 'RailCardOptionContainer',
            type: componentTypes.CONTAINER,
            name: 'Rail Card Option Container',
            label: 'RailCardOptionContainer',
            value: 'Rail Card Option',
            backgroundColor: '#005d8c',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            childComponents: ['RailCardOptionLabel']
        },
        RailCardOptionLabel: {
            id: 'RailCardOptionLabel',
            type: componentTypes.LABEL,
            name: 'Rail Card Option Label',
            label: 'Rail Card Option',
            value: 'Rail Card Option',
            color: '#FFF',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        RailCardNameContainer: {
            id: 'RailCardNameContainer',
            type: componentTypes.CONTAINER,
            name: 'RailCardNameContainer',
            label: 'RailCardNameContainer',
            value: '',
            backgroundColor: '#fff',
            fontSize: '15px',
            direction: 'horizontal',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            childComponents: ['RailCardLabel']
        },
        RailCardLabel: {
            id: 'RailCardLabel',
            type: componentTypes.LABEL,
            name: 'RailCardLabel',
            label: 'RailCardLabel',
            value: '',
            color: '#005d8c',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        RailCardContainer: {
            id: 'RailCardContainer',
            type: componentTypes.CONTAINER,
            name: 'Rail Card Container',
            label: 'Rail Card Container',
            value: '',
            color: '#333',
            backgroundColor: '#DFEAF0',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            direction: 'horizontal',
            childComponents: ['RailCardIconContainer', 'RailCardFromZoneContainer', 'RailCardToZoneContainer']
        },
        RailCardIconContainer: {
            id: 'RailCardIconContainer',
            type: componentTypes.CONTAINER_NO_PROPS,
            name: 'RailCardIconContainer',
            lg: 2,
            md: 2,
            sm: 2,
            direction: 'vertical'
        },
        RailCardFromZoneContainer: {
            id: 'RailCardFromZoneContainer',
            type: componentTypes.CONTAINER_NO_PROPS,
            name: 'RailCardFromZoneContainer',
            lg: 5,
            md: 5,
            sm: 5,
            direction: 'vertical',
            childComponents: ['FromZoneLabel', 'ValidFromDate']
        },
        FromZoneLabel: {
            id: 'FromZoneLabel',
            type: componentTypes.LABEL,
            name: 'FromZoneValue',
            label: 'From Zone: Value',
            value: '',
            color: '#999',
            fontWeight: '500',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        ValidFromDate: {
            id: 'ValidFromDate',
            type: componentTypes.LABEL,
            name: 'ValidFromDate',
            label: 'VALID FROM: DDD MMM dd YYYY at HH:MM',
            value: '',
            color: '#333',
            fontWeight: '500',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        RailCardToZoneContainer: {
            id: 'RailCardToZoneContainer',
            type: componentTypes.CONTAINER_NO_PROPS,
            name: 'RailCardToZoneContainer',
            lg: 5,
            md: 5,
            sm: 5,
            direction: 'vertical',
            childComponents: ['ToZoneLabel', 'ValidToDate']

        },
        ToZoneLabel: {
            id: 'ToZoneLabel',
            type: componentTypes.LABEL,
            name: 'ToZoneValue',
            label: 'To Zone: Value',
            value: '',
            color: '#999',
            fontWeight: '500',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        ValidToDate: {
            id: 'ValidToDate',
            type: componentTypes.LABEL,
            name: 'ValidToDate',
            label: 'Valid To: DDD MMM dd YYYY at HH:MM',
            value: '',
            color: '#333',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        RailCardInfoContainer: {
            id: 'RailCardInfoContainer',
            type: componentTypes.CONTAINER,
            name: 'RailCardInfoContainer',
            label: 'RailCardInfoContainer',
            value: '',
            backgroundColor: '#DFEAF0',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            direction: 'horizontal',
            childComponents: ['RailCardInfoLabel', 'RailCardInfoValue']
        },
        RailCardInfoLabel: {
            id: 'RailCardInfoLabel',
            type: componentTypes.LABEL,
            name: 'RailCardInfoLabel',
            label: 'Label',
            value: '',
            lg: 2,
            md: 2,
            sm: 2,
            color: '#333',
            fontWeight: '500',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        RailCardInfoValue: {
            id: 'RailCardInfoValue',
            type: componentTypes.LABEL,
            name: 'RailCardInfoValue',
            label: 'Value',
            value: '',
            lg: 2,
            md: 2,
            sm: 2,
            color: '#999',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        RailCardTotalContainer: {
            id: 'RailCardTotalContainer',
            type: componentTypes.CONTAINER,
            name: 'RailCardTotalContainer',
            label: 'RailCardTotalContainer',
            value: '',
            backgroundColor: '#DFEAF0',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            direction: 'horizontal',
            childComponents: ['RailCardTotalLabel', 'RailCardTotalValue']
        },
        RailCardTotalLabel: {
            id: 'RailCardTotalLabel',
            type: componentTypes.LABEL,
            name: 'RailCardTotalLabel',
            label: 'Total',
            value: '',
            lg: 2,
            md: 2,
            sm: 2,
            color: '#333',
            fontWeight: '500',
            fontSize: '18px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        RailCardTotalValue: {
            id: 'RailCardTotalValue',
            type: componentTypes.LABEL,
            name: 'RailCardTotalValue',
            label: '000.00 CUR',
            value: '',
            lg: 2,
            md: 2,
            sm: 2,
            color: '#333',
            fontSize: '18px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        RailCardCommentContainer: {
            id: 'RailCardCommentContainer',
            type: componentTypes.CONTAINER,
            name: 'RailCardCommentContainer',
            label: 'RailCardCommentContainer',
            value: '',
            backgroundColor: '#DFEAF0',
            direction: 'vertical',
            childComponents: ['RailCardComment']
        },
        RailCardComment: {
            id: 'RailCardComment',
            type: componentTypes.TEXTAREA,
            name: 'RailCardComment',
            label: 'Rail Card Comment',
            value: '',
            placeholder: 'Comment for Rail Cards',
            color: '#999',
            backgroundColor: '#FFF',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        RailCardRules: {
            id: 'RailCardRules',
            type: componentTypes.LABEL,
            name: 'RailCardRules',
            label: 'RULES: RULES CONTENT',
            value: '',
            placeholder: '',
            color: '#000',
            backgroundColor: '#000',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        // //////////////////////////
        // //// RAIL CARD RECEIPT///////
        railcardreceipt: {
            id: 'railcardreceipt',
            type: componentTypes.CAR,
            name: 'railcardreceipt',
            color: '#333',
            backgroundColor: '#fff',
            direction: 'vertical',
            childComponents: ['RCReceiptCategoryHeader', 'RCReceiptOptionContainer', 'RCReceiptNameContainer', 'RCReceiptContainer', 'RCReceiptInfoContainer', 'RCReceiptTotalContainer', 'RCReceiptCommentContainer', 'RCReceiptRules']
        },
        RCReceiptCategoryHeader: {
            id: 'RCReceiptCategoryHeader',
            type: componentTypes.CONTAINER,
            name: 'Rail Card Receipt Header',
            label: 'Rail Card Header',
            value: 'Rail Card Receipt Header',
            color: '#333',
            backgroundColor: '#0C3B55',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            childComponents: ['RCReceiptCategoryLabel']
        },
        RCReceiptCategoryLabel: {
            id: 'RCReceiptCategoryLabel',
            type: componentTypes.LABEL,
            name: 'Rail Receipt Category Label',
            label: 'Rail Receipt Category Label',
            value: 'Rail Receipt Category Label',
            color: '#FFF',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        RCReceiptOptionContainer: {
            id: 'RCReceiptOptionContainer',
            type: componentTypes.CONTAINER,
            name: 'Rail Card Receipt Option Container',
            label: 'RCReceiptOptionContainer',
            value: 'Rail Card Receipt Option',
            color: '#333',
            backgroundColor: '#005d8c',
            direction: 'horizontal',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            childComponents: ['RCReceiptNumberabel', 'RCReceiptNumber']
        },
        RCReceiptNumberabel: {
            id: 'RCReceiptNumberabel',
            type: componentTypes.LABEL,
            name: 'Rail Card Receipt Number Label',
            label: 'Rail Card Receipt Number Label',
            value: 'Rail Card Receipt Number Label',
            color: '#ffffff',
            lg: 9,
            md: 9,
            sm: 9,
            backgroundColor: '#005d8c',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        RCReceiptNumber: {
            id: 'RCReceiptNumber',
            type: componentTypes.LABEL,
            name: 'RC Receipt Number',
            label: 'Receipt Number',
            value: 'RC Receipt Number',
            color: '#ffffff',
            lg: 3,
            md: 3,
            sm: 3,
            backgroundColor: '#005d8c',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        RCReceiptNameContainer: {
            id: 'RCReceiptNameContainer',
            type: componentTypes.CONTAINER,
            name: 'RCReceiptNameContainer',
            label: 'RCReceiptNameContainer',
            value: '',
            backgroundColor: '#fff',
            direction: 'horizontal',
            childComponents: ['RCReceiptLabel', 'RCReceiptCardNumber']
        },
        RCReceiptLabel: {
            id: 'RCReceiptLabel',
            type: componentTypes.LABEL,
            name: 'Rail Card Receipt Name Label',
            label: 'Rail Card Name',
            value: '',
            color: '#005d8c',
            lg: 9,
            md: 9,
            sm: 9,
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        RCReceiptCardNumber: {
            id: 'RCReceiptCardNumber',
            type: componentTypes.LABEL,
            name: 'RailCardNumber',
            label: 'RailCardNumber',
            value: '',
            color: '#005d8c',
            lg: 3,
            md: 3,
            sm: 3,
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        RCReceiptContainer: {
            id: 'RCReceiptContainer',
            type: componentTypes.CONTAINER,
            name: 'Rail Card Receipt Container',
            label: 'Rail Card Receipt Container',
            value: '',
            backgroundColor: '#DFEAF0',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            direction: 'horizontal',
            childComponents: ['RCReceiptIconContainer', 'RCReceiptFromZoneContainer', 'RCReceiptToZoneContainer']
        },
        RCReceiptIconContainer: {
            id: 'RCReceiptIconContainer',
            type: componentTypes.CONTAINER_NO_PROPS,
            name: 'RCReceiptIconContainer',
            lg: 2,
            md: 2,
            sm: 2,
            direction: 'vertical'
        },
        RCReceiptFromZoneContainer: {
            id: 'RCReceiptFromZoneContainer',
            type: componentTypes.CONTAINER_NO_PROPS,
            name: 'RCReceiptFromZoneContainer',
            lg: 5,
            md: 5,
            sm: 5,
            direction: 'vertical',
            childComponents: ['RCRFromZoneLabel', 'RCRValidFromDate']
        },
        RCRFromZoneLabel: {
            id: 'RCRFromZoneLabel',
            type: componentTypes.LABEL,
            name: 'RCRFromZoneLabel',
            label: 'From Zone: Value',
            value: 'Zone Label',
            color: '#999',
            fontWeight: '500',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        RCRValidFromDate: {
            id: 'RCRValidFromDate',
            type: componentTypes.LABEL,
            name: 'Valid From Date',
            label: 'VALID FROM: DDD MMM dd YYYY at HH:MM',
            value: '',
            color: '#333',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        RCReceiptToZoneContainer: {
            id: 'RCReceiptToZoneContainer',
            type: componentTypes.CONTAINER_NO_PROPS,
            name: 'RCReceiptToZoneContainer',
            lg: 5,
            md: 5,
            sm: 5,
            direction: 'vertical',
            childComponents: ['RCRToZoneLabel', 'RCRValidToDate']

        },
        RCRToZoneLabel: {
            id: 'RCRToZoneLabel',
            type: componentTypes.LABEL,
            name: 'ToZoneLabel',
            label: 'To Zone: Value',
            value: 'To Zone',
            color: '#999',
            fontWeight: '500',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        RCRValidToDate: {
            id: 'RCRValidToDate',
            type: componentTypes.LABEL,
            name: 'Valid To Date',
            label: 'Valid To: DDD MMM dd YYYY at HH:MM',
            value: '',
            color: '#333',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        RCReceiptInfoContainer: {
            id: 'RCReceiptInfoContainer',
            type: componentTypes.CONTAINER,
            name: 'RCReceiptInfoContainer',
            label: 'RCReceiptInfoContainer',
            value: '',
            backgroundColor: '#DFEAF0',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            direction: 'horizontal',
            childComponents: ['RCReceiptInfoLabel', 'RCReceiptInfoValue']
        },
        RCReceiptInfoLabel: {
            id: 'RCReceiptInfoLabel',
            type: componentTypes.LABEL,
            name: 'RCReceiptInfoLabel',
            label: 'Label',
            value: '',
            lg: 2,
            md: 2,
            sm: 2,
            color: '#333',
            fontWeight: '500',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        RCReceiptInfoValue: {
            id: 'RCReceiptInfoValue',
            type: componentTypes.LABEL,
            name: 'RCReceiptInfoValue',
            label: 'Value',
            value: '',
            lg: 2,
            md: 2,
            sm: 2,
            color: '#999',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        RCReceiptTotalContainer: {
            id: 'RCReceiptTotalContainer',
            type: componentTypes.CONTAINER,
            name: 'RCReceiptTotalContainer',
            label: 'RCReceiptTotalContainer',
            value: '',
            backgroundColor: '#DFEAF0',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            direction: 'horizontal',
            childComponents: ['RCReceiptTotalLabel', 'RCReceiptTotalValue']
        },
        RCReceiptTotalLabel: {
            id: 'RCReceiptTotalLabel',
            type: componentTypes.LABEL,
            name: 'RCReceiptTotalLabel',
            label: 'Total',
            value: '',
            lg: 2,
            md: 2,
            sm: 2,
            fontWeight: '500',
            color: '#333',
            fontSize: '18px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        RCReceiptTotalValue: {
            id: 'RCReceiptTotalValue',
            type: componentTypes.LABEL,
            name: 'RCReceiptTotalValue',
            label: '000.00 CUR',
            value: '',
            lg: 2,
            md: 2,
            sm: 2,
            color: '#333',
            fontSize: '18px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        RCReceiptCommentContainer: {
            id: 'RCReceiptCommentContainer',
            type: componentTypes.CONTAINER,
            name: 'RCReceiptCommentContainer',
            label: 'RCReceiptCommentContainer',
            value: '',
            backgroundColor: '#DFEAF0',
            direction: 'vertical',
            childComponents: ['RCReceiptComment']
        },
        RCReceiptComment: {
            id: 'RCReceiptComment',
            type: componentTypes.TEXTAREA,
            name: 'RCReceiptComment',
            label: 'Rail Receipt Comment',
            value: '',
            placeholder: 'Comment for Rail Card Receipt',
            color: '#999',
            backgroundColor: '#fff',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        RCReceiptRules: {
            id: 'RCReceiptRules',
            type: componentTypes.LABEL,
            name: 'RCReceiptRules',
            label: 'RULES: RULES CONTENT',
            value: '',
            placeholder: '',
            color: '#000',
            backgroundColor: '#000',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        // //////////////////////////
        hotel: {
            id: 'hotel',
            type: componentTypes.HOTEL,
            name: 'hotel',
            color: '#333',
            backgroundColor: '#fff',
            direction: 'vertical',
            childComponents: ['HotelCategoryHeader', 'HotelOptionContainer', 'HotelNameContainer', 'HotelContainer', 'HotelRoomContainer', 'HotelPriceContainer', 'HotelCommentContainer']
        },
        HotelCategoryHeader: {
            id: 'HotelCategoryHeader',
            type: componentTypes.CONTAINER,
            name: 'HotelCategoryHeader',
            label: 'Hotel Category Header',
            value: 'Hotel Category Header',
            backgroundColor: '#0C3B55',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            childComponents: ['HotelCategoryLabel']
        },
        HotelCategoryLabel: {
            id: 'HotelCategoryLabel',
            type: componentTypes.LABEL,
            name: 'HotelCategoryLabel',
            label: 'Hotel Category Label',
            value: 'Hotel Category Label',
            color: '#FFF',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        HotelOptionContainer: {
            id: 'HotelOptionContainer',
            type: componentTypes.CONTAINER,
            name: 'HotelOptionContainer',
            label: 'HotelOptionContainer',
            value: 'Hotel Option',
            backgroundColor: '#005d8c',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            childComponents: ['HotelOptionLabel']
        },
        HotelOptionLabel: {
            id: 'HotelOptionLabel',
            type: componentTypes.LABEL,
            name: 'HotelOptionLabel',
            label: 'Hotel Option',
            value: 'Hotel Option',
            color: '#FFF',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        HotelNameContainer: {
            id: 'HotelNameContainer',
            type: componentTypes.CONTAINER,
            name: 'HotelNameContainer',
            label: 'HotelNameContainer',
            value: '',
            backgroundColor: '#fff',
            fontSize: '15px',
            direction: 'horizontal',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            childComponents: ['HotelNameLabel']
        },
        HotelNameLabel: {
            id: 'HotelNameLabel',
            type: componentTypes.LABEL,
            name: 'HotelNameLabel',
            label: 'Hotel Name',
            value: '',
            color: '#005d8c',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        HotelContainer: {
            id: 'HotelContainer',
            type: componentTypes.CONTAINER,
            name: 'HotelContainer',
            label: 'HotelContainer',
            value: '',
            backgroundColor: '#DFEAF0',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            direction: 'horizontal',
            childComponents: ['HotelIconContainer', 'HotelInfoContainer', 'HotelCheckinContainer']
        },
        HotelIconContainer: {
            id: 'HotelIconContainer',
            type: componentTypes.CONTAINER_NO_PROPS,
            name: 'HotelIconContainer',
            lg: 2,
            md: 2,
            sm: 2,
            direction: 'vertical'
        },
        HotelInfoContainer: {
            id: 'HotelInfoContainer',
            type: componentTypes.CONTAINER_NO_PROPS,
            name: 'HotelInfoContainer',
            lg: 5,
            md: 5,
            sm: 5,
            direction: 'vertical',
            childComponents: ['HotelInfoTitleLabel', 'HotelInfoValueLabel']
        },
        HotelInfoTitleLabel: {
            id: 'HotelInfoTitleLabel',
            type: componentTypes.LABEL,
            name: 'HotelInfoTitleLabel',
            label: 'Hotel Name',
            value: 'Hotel Name',
            color: '#999',
            fontWeight: '500',
            fontSize: '18px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        HotelInfoValueLabel: {
            id: 'HotelInfoValueLabel',
            type: componentTypes.LABEL,
            name: 'HotelInfoValueLabel',
            label: 'ADDRESS',
            value: '',
            color: '#333',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        HotelCheckinContainer: {
            id: 'HotelCheckinContainer',
            type: componentTypes.CONTAINER_NO_PROPS,
            name: 'HotelCheckinContainer',
            lg: 5,
            md: 5,
            sm: 5,
            direction: 'vertical',
            childComponents: ['CheckinTitleLabel', 'CheckinValueLabel', 'CheckoutTitleLabel', 'CheckoutValueLabel']
        },
        CheckinTitleLabel: {
            id: 'CheckinTitleLabel',
            type: componentTypes.LABEL,
            name: 'CheckinTitleLabel',
            label: 'Check in',
            value: 'Check in:',
            color: '#999',
            fontWeight: '500',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        CheckinValueLabel: {
            id: 'CheckinValueLabel',
            type: componentTypes.LABEL,
            name: 'CheckinValueLabel',
            label: 'DDD MMM dd YYYY',
            value: '',
            color: '#333',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        CheckoutTitleLabel: {
            id: 'CheckoutTitleLabel',
            type: componentTypes.LABEL,
            name: 'CheckoutTitleLabel',
            label: 'Check out',
            value: 'Check out:',
            color: '#999',
            fontWeight: '500',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        CheckoutValueLabel: {
            id: 'CheckoutValueLabel',
            type: componentTypes.LABEL,
            name: 'CheckoutValueLabel',
            label: 'DDD MMM dd YYYY',
            value: '',
            color: '#333',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        HotelRoomContainer: {
            id: 'HotelRoomContainer',
            type: componentTypes.CONTAINER,
            name: 'HotelRoomContainer',
            label: 'HotelRoomContainer',
            value: '',
            backgroundColor: '#DFEAF0',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            direction: 'horizontal',
            childComponents: ['HotelRoomLabel']
        },
        HotelRoomLabel: {
            id: 'HotelRoomLabel',
            type: componentTypes.LABEL,
            name: 'HotelRoomLabel',
            label: 'ROOM INFO ...',
            value: '',
            color: '#999',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        HotelPriceContainer: {
            id: 'HotelPriceContainer',
            type: componentTypes.CONTAINER,
            name: 'HotelPriceContainer',
            label: 'HotelPriceContainer',
            value: '',
            backgroundColor: '#DFEAF0',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            direction: 'horizontal',
            childComponents: ['PricePerNightContainer', 'ApproximateTotalContainer']
        },
        PricePerNightContainer: {
            id: 'PricePerNightContainer',
            type: componentTypes.CONTAINER_NO_PROPS,
            name: 'PricePerNightContainer',
            lg: 6,
            md: 6,
            sm: 6,
            direction: 'horizontal',
            childComponents: ['PricePerNightTitleLabel', 'PricePerNightValueLabel']
        },
        PricePerNightTitleLabel: {
            id: 'PricePerNightTitleLabel',
            type: componentTypes.LABEL,
            name: 'PricePerNightTitleLabel',
            label: 'Price per night',
            value: 'Price per night:',
            color: '#333',
            fontWeight: '500',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            lg: 6,
            md: 6,
            sm: 6
        },
        PricePerNightValueLabel: {
            id: 'PricePerNightValueLabel',
            type: componentTypes.LABEL,
            name: 'PricePerNightValueLabel',
            label: 'Value',
            value: '',
            color: '#999',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
            lg: 2,
            md: 2,
            sm: 2
        },
        ApproximateHotelTotalContainer: {
            id: 'ApproximateHotelTotalContainer',
            type: componentTypes.CONTAINER_NO_PROPS,
            name: 'ApproximateHotelTotalContainer',
            lg: 6,
            md: 6,
            sm: 6,
            direction: 'vertical',
            childComponents: ['ApproximateHotelTotalValueLabel', 'ApproximateHotelTotalTitleLabel']
        },
        ApproximateHotelTotalTitleLabel: {
            id: 'ApproximateHotelTotalTitleLabel',
            type: componentTypes.LABEL,
            name: 'ApproximateHotelTotalTitleLabel',
            label: 'Approximate total',
            value: 'Approximate total',
            color: '#666',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        ApproximateHotelTotalValueLabel: {
            id: 'ApproximateHotelTotalValueLabel',
            type: componentTypes.LABEL,
            name: 'ApproximateHotelTotalValueLabel',
            label: '000.00 CUR',
            value: '',
            color: '#333',
            fontSize: '18px',
            fontWeight: '500',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        HotelCommentContainer: {
            id: 'HotelCommentContainer',
            type: componentTypes.CONTAINER,
            name: 'HotelCommentContainer',
            backgroundColor: '#DFEAF0',
            direction: 'vertical',
            childComponents: ['HotelComment']
        },
        HotelComment: {
            id: 'HotelComment',
            type: componentTypes.TEXTAREA,
            name: 'CommentContainer',
            label: 'Hotel Comment',
            value: '',
            placeholder: 'Comment for hotel segments',
            color: '#999',
            backgroundColor: '#fff',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        },
        footer: {
            id: 'footer',
            type: componentTypes.TEXTAREA,
            name: 'Footer',
            label: 'Footer',
            value: '',
            placeholder: 'Type the Footer',
            color: '#999',
            backgroundColor: '#fff',
            fontSize: '15px',
            fontFamily: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value
        }
    };

    var template = {
        id: _uuid2.default.v4(),
        isDefault: false,
        name: 'NEW',
        markingId: '',
        description: '',
        subject: '',
        enabled: true,
        language: _languages.DEFAULT && _languages.DEFAULT.value,
        currencyFormat: _currencyFormats.DEFAULT && _currencyFormats.DEFAULT.value,
        timeFormat: _timeFormats.DEFAULT && _timeFormats.DEFAULT.value,
        logoAlignment: 'left',
        components: components
    };

    // FACTORY SINGLETON
    // -----------------------------------------------------------------------------------------------
    switch (type) {
        case VIEW_TRIP:
            return (0, _extends3.default)({}, template);

        case STANDARD:
        default:
            return template;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/templates/createTemplate.js
// module id = 1663
// module chunks = 0